import { useMutation } from "@apollo/client";
import {
  CREATE_WORKER_MUTATION,
  DELETE_WORKER_MUTATION,
  UPDATE_WORKER_MUTATION,
  WORKERS_QUERY,
} from "@/graphql/workers";

export const useCreateWorker = () => {
  return useMutation(CREATE_WORKER_MUTATION, {
    refetchQueries: [WORKERS_QUERY],
    onError: (error) => {
      console.error("Error creating worker:", error);
    },
  });
};

export const useUpdateWorker = () => {
  return useMutation(UPDATE_WORKER_MUTATION, {
    refetchQueries: [WORKERS_QUERY],
    onError: (error) => {
      console.error("Error updating worker:", error);
    },
  });
};

export const useDeleteWorker = () => {
  return useMutation(DELETE_WORKER_MUTATION, {
    refetchQueries: [WORKERS_QUERY],
    onError: (error) => {
      console.error("Error deleting worker:", error);
    },
  });
};
